export const allOtas = ["bookingdotcom", "agoda", "goibibo", "yatra", "expedia", "booklogic", "simplotel","easemytrip","akbartravels"];
export const otasExceptBooklogic = ["bookingdotcom", "agoda", "goibibo", "yatra", "expedia", "simplotel","easemytrip","akbartravels"];
